import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-gtia.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-gtia.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { FormControl, FormGroup } from "@angular/forms";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationDetailsGtiaConstants } from "./view-application-details-gtia.constants";
let ViewApplicationDetailsGtiaComponent = class ViewApplicationDetailsGtiaComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    changeDetectorRef;
    routerParamsService;
    detailsForm;
    descriptionFormControlName = ViewApplicationDetailsGtiaConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypesFormControlName = ViewApplicationDetailsGtiaConstants.APPLICATION_TYPES_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsGtiaConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    fileNumberFormControlName = ViewApplicationDetailsGtiaConstants.FILE_NUMBER_FORM_CONTROL_NAME;
    fileNumberLabel = ViewApplicationDetailsGtiaConstants.FILE_NUMBER_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    applicationTypeLabel = ViewApplicationDetailsGtiaConstants.APPLICATION_TYPE_LABEL;
    descriptionLabel = ViewApplicationDetailsGtiaConstants.DESCRIPTION_LABEL;
    applicationTypes = [];
    selectedApplicationSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appControllerService, changeDetectorRef, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.routerParamsService = routerParamsService;
        this.listenForRouteParamChange();
    }
    ngOnInit() {
        this.initForm();
        this.getLookups();
    }
    loadMetadata(stepMeta) {
    }
    handleRouteChange() {
    }
    getApplicationTypes() {
        return this.detailsForm.get("applicationTypes");
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID} and name eq 'ApplicationType' and deleted eq false`,
        };
        this.applicationViewService.getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationDetailsGtiaConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        this.applicationTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    this.applicationTypes.push(JSON.parse(item.content));
                }
            });
            this.changeDetectorRef.markForCheck();
            this.subscribeToSelectedApplication();
        }
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        this.detailsForm.get(this.fileNumberFormControlName).setValue(application.fileNumber);
        this.detailsForm.get(this.fileNumberFormControlName).disable();
        this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        this.detailsForm.get(this.descriptionFormControlName).disable();
        const appTypes = application.applicationTypes;
        this.setTypes(appTypes);
    }
    setTypes(appTypes) {
        const typesControl = this.getApplicationTypes();
        typesControl.clear();
        // sets application types from the application
        appTypes.forEach((applicationType) => {
            let appType = null;
            this.applicationTypes.forEach(item => {
                if (item?.value === applicationType.applicationType) {
                    appType = item;
                }
            });
            const typeGroup = new FormGroup({
                id: new FormControl(applicationType.id),
                applicationId: new FormControl(applicationType.applicationId),
                type: new FormControl({ value: appType?.value, disabled: true })
            });
            typesControl.push(typeGroup);
            typesControl.disable();
        });
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsGtiaComponent = __decorate([
    Component({
        selector: "app-view-application-details-gtia",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsGtiaComponent);
export { ViewApplicationDetailsGtiaComponent };
